export default __webpack_public_path__ + "static/media/Deacitvate.54658735.svg";